import React from 'react';
import "./onboard-dialog-dynamic-style.scss";
import {ReactComponent as ErrorIcon} from './images/error-icon.svg';
import {ReactComponent as WarningIcon} from './images/warning-icon.svg';
import {ReactComponent as InfoIcon} from './images/info-icon.svg';
import {ReactComponent as MoneyIcon} from './images/money-icon.svg';
import {ReactComponent as StarsIcon} from './images/stars-icon.svg';
import parse from 'html-react-parser';
import {useRecoilState} from "recoil";
import {dialogAtom} from "../../../store/DialogStore";

export const ICON_TYPE = {
    ERROR: 1,
    WARNING: 2,
    INFO: 3,
    MONEY: 4,
    STARS: 5
};

const OnboardDialogDynamic = () => {

    const [state, setState] = useRecoilState(dialogAtom);

    const {
        visible,
        title,
        content,
        moveCancelAndConfirm,
        cancel,
        confirm,
        icon
    } = state;

    const renderMoveCancelAndConfirm = () => {
        if (moveCancelAndConfirm) {
            return (
                <>
                    {cancel && <button onClick={() => cancel.click(setState)}
                                       className="onboard-dialog-dynamic-cancel">{cancel.label}</button>}
                    {confirm && <button onClick={() => confirm.click(setState)}
                                        className="onboard-dialog-dynamic-confirm">{confirm.label}</button>}
                </>
            )
        } else {
            return (
                <>
                    {confirm && <button onClick={() => confirm.click(setState)}
                                        className="onboard-dialog-dynamic-confirm">{confirm.label}</button>}
                    {cancel && <button onClick={() => cancel.click(setState)}
                                       className="onboard-dialog-dynamic-cancel">{cancel.label}</button>}
                </>
            )
        }
    }

    return (
        visible && (<div>
            <div className="onboard-dialog-dynamic-opacity"></div>
            <div className="onboard-dialog-dynamic-root">
                <div className="onboard-dialog-dynamic">
                    {(icon === ICON_TYPE.ERROR) && <ErrorIcon className={"onboard-dialog-dynamic-error-icon"}/>}
                    {(icon === ICON_TYPE.WARNING) && <WarningIcon className={"onboard-dialog-dynamic-warning-icon"}/>}
                    {(icon === ICON_TYPE.INFO) && <InfoIcon className={"onboard-dialog-dynamic-info-icon"}/>}
                    {(icon === ICON_TYPE.MONEY) && <MoneyIcon className={"onboard-dialog-dynamic-warning-icon"}/>}
                    {(icon === ICON_TYPE.STARS) && <StarsIcon className={"onboard-dialog-dynamic-warning-icon"}/>}
                    <p className="onboard-dialog-dynamic-title">{title}</p>
                    {content && (<p className="onboard-dialog-dynamic-content">{parse(content)}</p>)}
                    {renderMoveCancelAndConfirm()}
                </div>
            </div>
        </div>)
    )
};

export default OnboardDialogDynamic;
